import api from "@/services/api";
import { Promise } from "core-js";
import route from "@/router/index";

const BASE_URL = "/kasbon/driver-kasbons";

//#region state
const state = {
  driverKasbons: [],
  listCategory: [],
  listAccountNumber: [],
  lastFormNumber: null,
  lastKasbonNumber: null,
  driverKasbon: {},
  listDriverKasbon: [],
};
//#endregion

//#region getters
const getters = {};
//#region

//#region actions
const actions = {
  async create(context, body) {
    try {
      const response = await api.post(BASE_URL, body);
      if (response.status === 200) {
        context.dispatch(
          "toast",
          { type: "success", message: "Success Saved Data" },
          { root: true }
        );
        route.push({ name: "Detail Driver Kasbon", params: { id: response.data } });
      }
    } catch (error) {
      return Promise.reject(error);
    }
  },
  async getLastFormNumber(context) {
    try {
      const response = await api.get(`${BASE_URL}/form-number`);
      if (response.status === 200) {
        let num = "";
        let date = new Date();
        if (response.data === "New") {
          num = `DK.${date.getFullYear()}.${date.getMonth() + 1}.00001`;
        } else {
          const lastNumber = response.data ? response.data.split(".")[3] : "";
          const ctx = "" + (parseInt(lastNumber) + 1);
          const end = lastNumber.substr(0, lastNumber.length - ctx.length) + ctx;
          num = `DK.${date.getFullYear()}.${date.getMonth() + 1}.${end}`;
        }
        context.commit("SET_LAST_FORM_NUMBER", num);
      }
    } catch (error) {
      return Promise.reject(error);
    }
  },
  async getLastKasbonNumber(context) {
    try {
      const response = await api.get(`${BASE_URL}/kasbon-number`);
      if (response.status === 200) {
        context.commit("SET_LAST_KASBON_NUMBER", response.data);
      }
    } catch (error) {
      return Promise.reject(error);
    }
  },
  async getAll(context) {
    try {
      const response = await api.get(`${BASE_URL}`);
      if (response.status === 200) {
        context.commit("SET_DRIVER_KASBONS", response.data);
      }
    } catch (error) {
      return Promise.reject(error);
    }
  },
  async getById(context, id) {
    try {
      const response = await api.get(`${BASE_URL}/${id}`);
      return Promise.resolve(response);
    } catch (error) {
      return Promise.reject(error);
    }
  },
  async update(context, body) {
    try {
      const response = await api.put(`${BASE_URL}/${body.id}`, body);
      if (response.status === 200) {
        window.location.reload();
      }
    } catch (error) {
      return Promise.reject(error);
    }
  },
  async delete(context, id) {
    try {
      const response = await api.deleted(`${BASE_URL}/${id}`);
      if (response.status === 200) {
        route.push({ name: "Driver Kasbon" });
      }
    } catch (error) {
      return Promise.reject(error);
    }
  },
  async getListCategory() {
    try {
      const response = await api.get(`${BASE_URL}/requirement-category`);
      return Promise.resolve(response);
    } catch (error) {
      return Promise.reject(error);
    }
  },
  async getListAccountNumber(context, id) {
    try {
      const response = await api.get(`${BASE_URL}/account-number/${id}`);
      if (response.status === 200) {
        context.commit("SET_LIST_ACCOUNT_NUMBER", response.data);
      }
    } catch (error) {
      return Promise.reject(error);
    }
  },
  async getListDriverKasbon() {
    try {
      const response = await api.get(`${BASE_URL}/dropdown`);
      return Promise.resolve(response);
    } catch (error) {
      return Promise.reject(error);
    }
  },
  async getListDriverKasbonForSettlement() {
    try {
      const response = await api.get(`${BASE_URL}/dropdown/settlement/approved`);
      return Promise.resolve(response);
    } catch (error) {
      return Promise.reject(error);
    }
  },
  async getListDriverKasbonForSettlementAll() {
    try {
      const response = await api.get(`${BASE_URL}/dropdown/settlement/all`);
      return Promise.resolve(response);
    } catch (error) {
      return Promise.reject(error);
    }
  },
};
//#endregion

//#region mutations
const mutations = {
  SET_LAST_FORM_NUMBER(state, payload) {
    state.lastFormNumber = payload;
  },
  SET_LAST_KASBON_NUMBER(state, payload) {
    state.lastKasbonNumber = payload;
  },
  SET_DRIVER_KASBON(state, payload) {
    state.driverKasbon = payload;
  },
  SET_DRIVER_KASBONS(state, payload) {
    state.driverKasbons = payload;
  },
  SET_LIST_CATEGORY(state, payload) {
    state.listCategory = payload;
  },
  SET_LIST_ACCOUNT_NUMBER(state, payload) {
    state.listAccountNumber = payload;
  },
  SET_LIST_DRIVER_KASBON(state, payload) {
    state.listDriverKasbon = payload;
  },
};
//#endregion

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
